export default __webpack_public_path__ + "static/media/gameI-mobile-intro2.8f98b063.png";